import * as types from "../mutation-type"
import axios from 'axios'
import { OP_TYPE, NODE_URL } from "../../helpers/consts";
import { client, ParameterType } from '@ont-dev/ontology-dapi';


export default {
  state: {
    Debugger: undefined,
    DebuggerLine: undefined,
    EvaluationStack: undefined,
    AltStack: undefined,
    History: undefined,
    Locals: undefined,
    RunStatus : {
      running : false
    },
    RunInfo: {
      contractHash:'',
    },

  },
  mutations: {
    [types.SET_DEBUGGER](state, payload) {
      state.Debugger = payload.debug;
    },
    [types.SET_DEBUGGER_STATE](state, payload) {
      state.DebuggerLine = payload.line;
      state.EvaluationStack = payload.evaluationStack;
      state.AltStack = payload.altStack;
      state.History = payload.history;
      state.Locals = payload.locals;
    },
    [types.SET_RUN_STATUS](state, payload) {
      state.RunStatus.running = payload.running
    },
    [types.SET_CONTRACT_HASH](state, payload) {
      state.RunInfo = Object.assign({}, { contractHash: payload.info} )
    },
    [types.CLEAR_CONTRACT_HASH](state) {
      state.RunInfo.contractHash = ''
    },
  },
    actions: {
        async getNetwork() { 
            try {
                const network = await client.api.network.getNetwork();
                console.log(network);
                return network;
            } catch (err) {
                console.log(err);
                return;
                alert('Network error with Cyano wallet.')
            }
        },
    setContractHash({dispatch, commit},$contractHash) {
      commit({
        type: types.SET_CONTRACT_HASH,
        info: $contractHash
      })
    },
    clearContractHash({dispatch, commit}){
      commit({
        type: types.CLEAR_CONTRACT_HASH,
      })
    },
    async dapiInvoke({commit}, params) {
      const {contract, method, parameters, gasPrice, gasLimit, requireIdentity, isWasmVm} = params
      try {
        const account = await client.api.asset.getAccount();
      } catch (err) {
        console.log(err)
        return 'NO_ACCOUNT';
      }
      try {
          let result;
          if (isWasmVm) {
            result = await client.api.smartContract.invokeWasm({
                contract,
                method,
                parameters,
                gasPrice,
                gasLimit,
                requireIdentity});
          } else {
            result = await client.api.smartContract.invoke({
                contract,
                method,
                parameters,
                gasPrice,
                gasLimit,
                requireIdentity});
          }
        console.log('onScCall finished, result:' + JSON.stringify(result));
        commit({
          type: types.APPEND_OUTPUT_LOG,
          log: result,
          op: OP_TYPE.Invoke
        })
        return result;
      } catch (e) {
        let log = e;
        console.log('onScCall error:', e);
        if(e === 'OTHER') {
          log = 'Invoke contract faield.'
        }
        commit({
          type: types.APPEND_OUTPUT_LOG,
          log: log,
          op: OP_TYPE.Invoke
        })
        return e;
      }
    },
    async dapiInvokeRead({ commit }, params) {
      const { contract, method, parameters, isWasmVm} = params
      try {
          let result;
          if (isWasmVm) {
            result = await client.api.smartContract.invokeWasmRead({
                contract,
                method,
                parameters
              });
          } else {
            result = await client.api.smartContract.invokeRead({
                contract,
                method,
                parameters
              });
          }
              
        console.log('onScCall finished, result:' + JSON.stringify(result));
        commit({
          type: types.APPEND_OUTPUT_LOG,
          log: result,
          op: OP_TYPE.Invoke
        })
        return result;
      } catch (e) {
        let log = e;
        console.log('onScCall error:', e);
        if (e === 'OTHER') {
          log = 'Other errors'
        }
        commit({
          type: types.APPEND_OUTPUT_LOG,
          log: log,
          op: OP_TYPE.Invoke
        })
        return e;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/run.js